(function ($) {
    'use strict';

    var $doc = $(document);

    $doc.on('click', '[data-toggle="popel-populate"]', function () {
        var $this   = $(this),
            $target = $($this.data('target')),
            value   = $this.data('value');

        if (!$target || $target.length < 1) {
            return true;
        }

        $target.val(String(value));
    });
})(window.jQuery);
